import axios from 'axios';
import { toast } from 'react-toastify';
import {
  APP_SETTING_CHANGE_PROJECT_LOADING_ICON_BEGIN,
  APP_SETTING_CHANGE_PROJECT_LOADING_ICON_SUCCESS,
  APP_SETTING_CHANGE_PROJECT_LOADING_ICON_FAILURE,
  APP_SETTING_CHANGE_PROJECT_LOADING_ICON_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function changeProjectLoadingIcon(args = {}) {
  return (dispatch) => {
    dispatch({
      type: APP_SETTING_CHANGE_PROJECT_LOADING_ICON_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/loading-icon`,
        { loadingIconKey: args.loadingIconKey },
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: APP_SETTING_CHANGE_PROJECT_LOADING_ICON_SUCCESS,
              data: res.data,
            });
            toast.success('Saved Successfully !', {});
            resolve(res);
          } else {
            dispatch({
              type: APP_SETTING_CHANGE_PROJECT_LOADING_ICON_FAILURE,
              data: { error: 'Failed' },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: APP_SETTING_CHANGE_PROJECT_LOADING_ICON_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err);
          toast.error(`Failed: ${errMsg}` || 'Update Failed');
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissChangeProjectLoadingIconError() {
  return {
    type: APP_SETTING_CHANGE_PROJECT_LOADING_ICON_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_CHANGE_PROJECT_LOADING_ICON_BEGIN:
      return {
        ...state,
        changeProjectLoadingIconPending: true,
        changeProjectLoadingIconError: null,
      };

    case APP_SETTING_CHANGE_PROJECT_LOADING_ICON_SUCCESS:
      return {
        ...state,
        changeProjectLoadingIconPending: false,
        changeProjectLoadingIconError: null,
        projectDetail: action.data,
      };

    case APP_SETTING_CHANGE_PROJECT_LOADING_ICON_FAILURE:
      return {
        ...state,
        changeProjectLoadingIconPending: false,
        changeProjectLoadingIconError: action.data.error,
      };

    case APP_SETTING_CHANGE_PROJECT_LOADING_ICON_DISMISS_ERROR:
      return {
        ...state,
        changeProjectLoadingIconError: null,
      };

    default:
      return state;
  }
}
